module.exports = __webpack_public_path__ + "6353e99d77cf31a63b81eca874f095d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/page/author/images/original-user-bg.jpg
// module id = 1085
// module chunks = 3